
import React from 'react';
import PropTypes from 'prop-types';

import restrictNumber from '../../../utils/restrictNumber';
import {
  StyledOptionSliderSlot,
  StyledOptionStack,
  StyledSpacedOptionFields,
} from './AnnotationOptions.styled';
import Slider from '../Slider';

const MIN_PERCENTANGE = 0;
const MAX_PERCENTANGE = 1;
const POPUP_SLIDER_WIDTH = '100%';

const OpacityField = ({ annotation, updateAnnotation, t }) => {
  const { opacity } = annotation;

  const changeOpacity = (newOpactiy) => {
    updateAnnotation({
      opacity: restrictNumber(
        newOpactiy / 100,
        MIN_PERCENTANGE,
        MAX_PERCENTANGE,
      ),
    });
  };

  return (
    <StyledSpacedOptionFields className="respark_annotation-option-panel">
      <StyledOptionStack>
        <StyledOptionSliderSlot>
          <Slider
            width={POPUP_SLIDER_WIDTH}
            annotation="%"
            onChange={changeOpacity}
            value={Math.round(opacity * 100)}
          />
        </StyledOptionSliderSlot>
      </StyledOptionStack>
    </StyledSpacedOptionFields>
  );
};

OpacityField.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  updateAnnotation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default OpacityField;
